<div class="delete-menu-group-dialog">
    <h2 mat-dialog-title class="dialog-title">
        <i class="ri-alert-line text-danger me-2"></i>
        Confirmar Eliminación
    </h2>
    <mat-dialog-content class="dialog-content">
        <p class="warning-message">
            ¿Está seguro de que desea eliminar el grupo de menú <strong>{{ data.menuGroup.nombre }}</strong>?
        </p>
        <div class="detail-item">
            <span class="detail-label">Orden:</span>
            <span class="detail-value">{{ data.menuGroup.orden }}</span>
        </div>
        <div class="alert-warning">
            <i class="ri-information-line me-2"></i>
            <span>No se puede eliminar un grupo que tenga módulos asociados. Si el grupo tiene módulos, deberá reasignarlos o eliminarlos antes.</span>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions">
        <button mat-button (click)="onCancel()" class="cancel-button">
            <i class="ri-close-line me-2"></i>
            Cancelar
        </button>
        <button mat-raised-button color="warn" (click)="onConfirm()" class="confirm-button">
            <i class="ri-delete-bin-line me-2"></i>
            Eliminar
        </button>
    </mat-dialog-actions>
</div>
